/**
 * Initializes live ticker if present on page
 */
async function initNavigationMenuPages() {
    const menuPages = document.querySelectorAll('#mainnavigation .nav-link.menupage');
    menuPages.forEach((menuPage) => {
        menuPage.addEventListener('click', (event) => {
            event.preventDefault();
        });
    });
}

export { initNavigationMenuPages };